module.exports = __webpack_public_path__ + "static/media/settled-bg.2fee21e7.png";